import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { HeaderComponent } from '../components/header/header.component';
import { BannerComponent } from '../components/banner/banner.component';
import { SideMenuComponent } from '../components/side-menu/side-menu.component';
import { ModalComponent } from './modal/modal.component';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FooterComponent } from './footer/footer.component';
import { SideNavContentComponent } from './side-nav-content/side-nav-content/side-nav-content.component';
import { LoaderComponent } from './loader/loader.component';
import { AlertComponent } from './alert/alert.component';

@NgModule({
  declarations: [
    HeaderComponent,
    BannerComponent,
    SideMenuComponent,
    ModalComponent,
    FooterComponent,
    SideNavContentComponent,
    LoaderComponent,
    AlertComponent
  ],
  imports: [
    CommonModule,
    NgbModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [
    HeaderComponent,
    BannerComponent,
    SideMenuComponent,
    ModalComponent,
    FooterComponent,
    SideNavContentComponent,
    LoaderComponent,
    AlertComponent
  ],
  entryComponents: [],
  providers: [],
})
export class ComponentsModule { }
